import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=e682c666&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=e682c666&lang=scss"
import style1 from "./Index.vue?vue&type=style&index=1&id=e682c666&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e682c666",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e682c666')) {
      api.createRecord('e682c666', component.options)
    } else {
      api.reload('e682c666', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=e682c666&scoped=true", function () {
      api.rerender('e682c666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Hotel/Index.vue"
export default component.exports